var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRightarrow(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 29.994,
    height: 14.528,
    viewBox: "0 0 29.994 14.528",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_2966",
    "data-name": "Group 2966",
    transform: "translate(0 14.528) rotate(-90)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2965",
    "data-name": "Group 2965"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4527",
    "data-name": "Path 4527",
    d: "M7.964,1.146l.543,24.812,4-4.2a1.172,1.172,0,0,1,1.7,1.617L8.246,29.63h0a1.173,1.173,0,0,1-1.659.037h0L.359,23.678a1.172,1.172,0,0,1,1.625-1.689l4.18,4.02L5.621,1.2a1.172,1.172,0,0,1,2.343-.051Z",
    fill: "#fff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRightarrow);
export default __webpack_public_path__ + "static/media/rightarrow.d9a34b2540153a52bf43e57564edb549.svg";
export { ForwardRef as ReactComponent };